import { Realm, Topic } from "../../../../api/types";
import { AnimalLogo } from "../../assets/icon/AnimalLogo";
import { BoneLogo } from "../../assets/icon/BoneLogo";
import { LeafLogo } from "../../assets/icon/LeafLogo";
import { DNALogo } from "../../assets/icon/DNALogo";
import { MedicineLogo } from "../../assets/icon/MedicineLogo";
import { InventionLogo } from "../../assets/icon/InventionLogo";
import { MathLogo } from "../../assets/icon/MathLogo";
import { ChemistryLogo } from "../../assets/icon/ChemistryLogo";
import { RocketLogo } from "../../assets/icon/RocketLogo";
import { LightningLogo } from "../../assets/icon/LightningLogo";
import React from "react";

export interface DisplayTopic {
	realm: Realm;
	name: Topic;
	icon: JSX.Element;
	color: string;
}
export const topics: DisplayTopic[] = [
	{
		realm: "Habiterra",
		name: "Animals",
		icon: <AnimalLogo />,
		color: "#c3f6f0",
	},
	{
		realm: "Prehistoric Point",
		name: "Dinosaurs and Fossils",
		icon: <BoneLogo />,
		color: "#f0ece2",
	},
	{
		realm: "Green Acres",
		name: "Environment & Nature",
		icon: <LeafLogo />,
		color: "#d3f2ce",
	},
	{
		realm: "DNAtion",
		name: "Life & Evolution",
		icon: <DNALogo />,
		color: "#c7e8f7",
	},
	{
		realm: "Elixir Institute",
		name: "Medicine & Health",
		icon: <MedicineLogo />,
		color: "#f9d6d6",
	},
	{
		realm: "Edison's Isle",
		name: "Inventions",
		icon: <InventionLogo />,
		color: "#f9ecf2",
	},
	{
		realm: "Pythagoras Peninsula",
		name: "Mathematics",
		icon: <MathLogo />,
		color: "#fee1d4",
	},
	{
		realm: "E=MC Square",
		name: "Physics",
		icon: <ChemistryLogo />,
		color: "#fddcf4",
	},
	{
		realm: "Cape Cosmos",
		name: "Space",
		icon: <RocketLogo />,
		color: "#dfe2f7",
	},
	{
		realm: "Fahren Heights",
		name: "Weather",
		icon: <LightningLogo />,
		color: "#fef9e4",
	},
];

export type RealmTopicMap = {
	[key in Realm]: DisplayTopic;
};

export const realmTopicMap = topics.reduce((acc, topic) => {
	acc[topic.realm] = topic;
	return acc;
}, {} as RealmTopicMap);
